import axios from "axios";
import config from "../../config";

const BASE_URL = `${config.url}/api/categories`;

const CategoryManager = {
  // Get all categories
  async getAllCategories() {
    const response = await axios.get(`${BASE_URL}/get`);
    // Assuming your API returns an object like:
    // { responseCode: 200, errorCode: null, responseMessage: "...", responseData: [...] }
    return response.data;
  },

  // Get single category by ID
  async getCategoryById(id) {
    const response = await axios.get(`${BASE_URL}/get/${id}`);
    return response.data;
  },

};

export default CategoryManager;
